export class NoteModel {
    public id: string;
    public title: string;
    public content: string;
    public coordinator_name: string;
    public is_coordinator: boolean;
    public dealId: string;
    public internal: boolean;
    public step_history_name: string;
    public updated_at: string;

    public showMenu: boolean = false;

    constructor(
        id: string,
        title: string,
        content: string,
        coordinator_name: string,
        is_coordinator: boolean,
        dealId: string,
        internal: boolean,
        step_history_name: string,
        updated_at: string
    ) {
        this.id = id;
        this.title = title;
        this.content = content;
        this.coordinator_name = coordinator_name;
        this.is_coordinator = is_coordinator;
        this.internal = internal;
        this.step_history_name = step_history_name;
        this.dealId = dealId;
        this.updated_at = updated_at;
    }

    setPrivate(): void {
        this.internal = true;
    }

    setPublic(): void {
        this.internal = false;
    }

    togglePrivacity(): void {
        this.internal = !this.internal;
    }

    toggleMenu(): void {
        this.showMenu = !this.showMenu;
    }
}
